<template>
    <v-dialog
        v-model="visible"
        width="500"
        :persistent="true"
    >
        <v-card>
            <v-card-text>
                <div class="content-card-text">
                    <p>您已进入投保页面</p>
                    <p>将记录您的投保行为</p>
                </div>
            </v-card-text>
            <v-divider />
            <div class="btn-card-content">
                <div class="btn-card-content-div">
                    <v-btn
                        large
                        :color="buttonColor"
                        @click="closeDialog"
                    >{{ buttonValue }}</v-btn>
                </div>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            value: {
                type: Boolean,
                default: true
            },
            startTime: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                v_disabled: "disabled",
                timeDown: 5,
                buttonValue: "",
                countDownInterval: "",
                buttonColor: "disabled",
            }
        },
        computed:{
            visible: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit("input", v);
                }
            },
        },
        mounted() {
            this.buttonValue = this.timeDown;
            this.countDownInterval = setInterval(this.countDown, 1000);
        },
        methods: {
            countDown(){
                if(this.startTime === false){
                    return;
                }
                if (this.timeDown <= 1){
                    this.buttonValue = "我知道了";
                    this.buttonColor = "primary";
                    clearInterval(this.countDownInterval);
                    this.timeDown--;
                    return false;
                }
                this.timeDown--;
                this.buttonValue = this.timeDown;
            },
            closeDialog(){
                if (this.timeDown > 0){
                    return false;
                }
                this.visible = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .content-card-text p{
        text-align: center;
    }
    .btn-card-content{
        position: relative;
        height: 58px;
        .btn-card-content-div{
            margin: 0 auto;
            text-align: center;
        }
    }
</style>
